export default __webpack_public_path__ + "static/media/yellowbg.b0690f04.svg";